import { fontOptions } from "./model";
import { AlbumTitle } from "./AlbumTitle";

export function AlbumFontPicker({ value, onChange, name, disabled = false }: {
  value: string; onChange: (value: string) => void; name: string; disabled?: boolean;
}) {
  return <div className="album-font-picker">
    <label htmlFor="album-title-font">Album Title Font</label>
    <select id="album-title-font" value={value} onChange={event => onChange(event.target.value)} disabled={disabled}>
      <option value="">Use library font</option>
      {fontOptions.map(font => <option key={font.value} value={font.value}>{font.label}</option>)}
    </select>
    <p className="form-note">Applies to the album name and creation date.</p>
    <div className="album-font-preview"><AlbumTitle name={name.trim() || "Untitled Gallery"} createdAt={new Date().toISOString()} fontFamily={value} /></div>
  </div>;
}
